import React, { useMemo } from 'react';
import { Spin } from 'antd';
import Drawer from '../../../components/AppDrawer';
import CampaignForm from './CampaignForm';
import { useCampaign } from '../hooks/useCampaign';
import type { CampaignFormValues } from '../types';

export interface CampaignFormDrawerProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  editCampaignId?: string | null;
}

const CampaignFormDrawer: React.FC<CampaignFormDrawerProps> = ({
  open,
  onClose,
  onSuccess,
  editCampaignId,
}) => {
  const isEdit = Boolean(editCampaignId);
  const { data: campaign, isLoading: loadingCampaign } = useCampaign(
    open && editCampaignId ? editCampaignId : null
  );

  const initialValues = useMemo((): Partial<CampaignFormValues> | null => {
    if (!campaign) return null;
    return {
      name: campaign.name,
      description: campaign.description ?? undefined,
      channelId: campaign.channelId,
      status: campaign.status,
      startDateUtc: campaign.startDateUtc ?? undefined,
      endDateUtc: campaign.endDateUtc ?? undefined,
      budget: campaign.budget ?? undefined,
      targetedAmountGoal: campaign.targetedAmountGoal ?? undefined,
      tags: campaign.tags,
    };
  }, [campaign]);

  return (
    <Drawer
      title={isEdit ? 'Edit Campaign' : 'Add Campaign'}
      open={open}
      onClose={onClose}
      width={720}
      destroyOnClose
      footer={null}
      placement="right"
    >
      {isEdit && loadingCampaign ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : (
        <CampaignForm
          mode={isEdit ? 'edit' : 'add'}
          editCampaignId={editCampaignId ?? undefined}
          initialValues={isEdit ? initialValues : undefined}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      )}
    </Drawer>
  );
};

export default CampaignFormDrawer;
